import React from "react";

import Link from "@whoppah/next/link";
import { useRouter } from "next/router";

import { useAuth } from "auth";

import useUpdateMe from "../../scenes/auth/hooks/useUpdateMe";
import { setLocaleCookie } from "@/common/utils/cookie.utils";
import { cn } from "@/common/utils/css.utils";

const LANGUAGE_MAP = {
  en: "EN_US",
  nl: "NL_NL",
};

const LangButton = ({ locale, handleChange }) => {
  const router = useRouter();
  const isActive = router.locale === locale;

  const [path, search] = router.asPath.split("?");
  const searchParams = new URLSearchParams(search);
  searchParams.delete("search");
  const searchParamsString = searchParams.toString();

  const linkProps = {
    className: cn(
      "w-full px-2 py-2 text-sm text-[#282F36] focus:outline-none",
      { "pointer-events-none text-primary-600": isActive }
    ),
    onClick: () => handleChange(locale),
  };

  return (
    <div className="flex flex-col items-center px-2">
      {isActive ? (
        <a {...linkProps}>{locale?.toUpperCase()}</a>
      ) : (
        <Link
          href={
            searchParamsString ? [path, searchParamsString].join("?") : path
          }
          locale={locale}
          prefetch={false}
          {...linkProps}
        >
          {locale?.toUpperCase()}
        </Link>
      )}
      <div
        className={cn("h-1 w-3/4 rounded-tl rounded-tr", {
          "bg-primary-500": isActive,
        })}
      />
    </div>
  );
};

export const LangSwitcher = () => {
  const { isLoggedIn } = useAuth();
  const router = useRouter();
  const { locales } = router;

  const [updateMe] = useUpdateMe();

  const updateUserLanguage = async locale => {
    if (!isLoggedIn) {
      return;
    }
    await updateMe({ variables: { locale } });
  };

  const handleChange = async locale => {
    setLocaleCookie(locale);
    await updateUserLanguage(LANGUAGE_MAP[locale]);
  };

  return (
    <div className="flex">
      {[...locales]
        .sort((a, b) => b.localeCompare(a))
        .map(locale => (
          <LangButton
            key={locale}
            locale={locale}
            handleChange={handleChange}
          />
        ))}
    </div>
  );
};
